import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { OutlinedButton } from '../../../../../components/Button'
import { ParameterDetailsSelector } from '../../../../../store/parameterDetails'
import { useStyles } from '../../../../../theme'
import { ReadingScale } from '../ReadingScale'
import { CautionCard } from './CautionCard'
import { SafeCard } from './SafeCard'
import { UnsafeCard } from './UnsafeCard'
import { AppDispatch } from '../../../../../store'
import { WaterInfoActions } from '../../../../../store/waterInfo'

interface ParameterDrawerDetailProps {
  onClose: () => void
}

export const ParameterDrawerDetail: FC<ParameterDrawerDetailProps> = ({ onClose }) => {
  const theme = useTheme()
  const styles = useStyles()
  const dispatch = useDispatch<AppDispatch>()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const selectedParameter = useSelector(ParameterDetailsSelector.selectSelectedParameter)
  const parameterDetails = useSelector(ParameterDetailsSelector.selectParameterDetailsState)

  const handleViewMore = async () => {

    dispatch(WaterInfoActions.setSelectedWaterParameter(selectedParameter!.name))
    dispatch(WaterInfoActions.toggleIsOpen())
  }


  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        height: isMobile ? '100%' :'100vh',
        flex: '1 0 100%',
        p: '24px',
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        borderBottom={`1px solid ${theme.palette.divider}`}
        pb={2}
        sx={{ flexShrink: 1 }}
      >
        <Typography fontWeight="bold" color="primary.dark" fontSize={'1.2rem'}>
          {parameterDetails?.name}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Stack sx={{ overflowY: 'auto', flex: '1 1 auto', ...styles.scrollbar, px:'4px' }}>
        <ReadingScale />
        {selectedParameter?.label === 'High' && <UnsafeCard />}
        {selectedParameter?.label === 'Low' && <UnsafeCard />}
        {selectedParameter?.label === 'Good' && <SafeCard />}
        {selectedParameter?.label === 'Caution' && <CautionCard />}
        <Stack
          sx={{my:"8px"}}
          spacing={1}
          borderBottom={`1px solid ${theme.palette.divider}`}
          pb={2}>
          <Typography
            fontWeight={theme.typography.fontWeightBold}
            color={'primary.dark'}
            fontSize={'1rem'}

          >
            {parameterDetails?.name}
          </Typography>

          <Box   alignItems="start" px={1}>

            <Typography
              color={theme.palette.grey[600]}
              fontSize={'0.9rem'}
              fontWeight={theme.typography.fontWeightMedium}
            >
              {parameterDetails?.epa_regulation &&
                parameterDetails?.epa_regulation.contaminant_sources}
            </Typography>
          </Box>
        </Stack>

        <Box sx={{ py: 1 }}>
          <OutlinedButton size="large" fullWidth onClick={handleViewMore}>
            View More
          </OutlinedButton>
        </Box>
      </Stack>
    </Box>
  )
}
